export default {
  existing_documents: {
    description:
      'Vous avez déjà téléversé les documents suivants. Sélectionnez-en un et appuyez sur Envoyer, ou téléversez un nouveau document.',
    sides: {
      front: 'Recto',
      back: 'Verso',
    },
    created_at: 'Téléversé le : {{date}}',
    expires_at: 'Expire le : {{date}}',
  },
  document_types: {
    owner_document: "Document d'identité du propriétaire",
    business_document: "Document d'entreprise",
  },
  form: {
    document_type: {
      label: "Document justificatif d'identité",
      placeholder: 'Sélectionner le type de document',
      options: {
        passport: 'Passeport',
        driver_license: 'Permis de conduire',
        id_card: "Carte d'identité",
        residence_permit: 'Titre de séjour',
      },
    },
    front: {
      label: 'Recto du document',
    },
    back: {
      label: 'Verso du document (optionnel pour certains documents)',
    },
    expires_at: {
      label: "Date d'expiration du document",
      placeholder: "Sélectionner la date d'expiration",
    },
  },
  buttons: {
    select_file: 'Sélectionner un fichier',
    next: 'Suivant',
    back: 'Verso',
    send: 'Envoyer',
    upload_new: 'Téléverser un nouveau document',
    use_existing: 'Utiliser un document déjà téléversé',
  },
};
